import { useKPILibraryContext } from '@context/KPILibraryContext';
import Button from '@mui/material/Button';
import { RootKPI } from '@services/api/deckManagement/graphql/schema/API';

interface EditRootKPICellRendererProps {
  data: RootKPI;
}

/**
 * Cell renderer for the Edit action in the Root KPI grid.
 * Clicking Edit selects the Root KPI in context, which switches the library to the Variant view.
 */
const EditRootKPICellRenderer = ({ data }: EditRootKPICellRendererProps) => {
  const { setSelectedRootKPI } = useKPILibraryContext();

  return (
    <Button variant='text' onClick={() => setSelectedRootKPI(data)}>
      Edit
    </Button>
  );
};

export default EditRootKPICellRenderer;
